













































import CommonIconBtn from './CommonIconBtn.vue';
import SubmitBtn from '@/components/Common/SubmitBtn.vue';
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'searchGroup',
  components: {
    SubmitBtn,
    CommonIconBtn
  },
})
export default class SearchGroup extends Vue {
  @Prop({ type: Boolean, default: false}) public searchLoading!: boolean;
  @Prop({ type: Boolean, default: true}) public showReset!: boolean;
  @Prop({ type: Boolean, default: false}) public showExport!: boolean;
  @Prop({ type: Boolean, default: false}) public showRefresh!: boolean;
  @Prop({ type: String, default: 'flex-start'}) public justifyContent!: string;

  public handleSearch() {
    this.$emit('search');
  }

  public handleReset() {
    this.$emit('reset');
  }

  public handleExport() {
    if (this.showExport) {
      this.$emit('export');
    }
  }
}
